<app-wrapper size="xl">
  <div class="mylist-icatch">
    <button (click)="bannerClick.emit()"><img src="assets/images/nyushi_digi_premium_2304.jpg" width="600" height="100" /></button>
  </div>
</app-wrapper>
